export default "__VITE_PUBLIC_ASSET__7cc50b0b__"